import { useState } from 'react';
import { Select } from 'antd';
import { Icon } from 'Components';
import Alert from '../components/Alert';
import StepFooter from './StepFooter';
const { Option } = Select;

const mockRecipients = [
  'acolque@marriott.com',
  'acolque',
  'admin1@testmail.com',
  'admin2@testmail.com',
  'admin3@testmail.com',
  'admin4@testmail.com',
  'admin5@testmail.com',
];

type TestConfigurationProps = {
  onBack: () => void;
  onNext: (emails: string[]) => void;
  setErrorMessage: (message: string) => void
};

const CloseIcon = () => (
  <Icon type="campaignStepClose" />
);

const tagRender = (props: any) => {
  const { label, closable, onClose } = props;

  return (
    <span className="ml-chip">
      <span className="ml-chip-text">{label}</span>

      {closable && (
        <span
          className="ml-chip-close"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </span>
      )}
    </span>
  );
};

const TestConfiguration = ({ onBack, onNext }: TestConfigurationProps) => {
  const [recipients, setRecipients] = useState<string[]>([]);
  const [emailError, setEmailError] = useState<string | null>(null);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const hasInvalidEmail = (emails: string[]) =>
    emails.some(email => !emailRegex.test(email));

  const handleChange = (values: string[]) => {
    setRecipients(values);
    if (hasInvalidEmail(values)) {
      setEmailError("Enter a valid email address");
    } else {
      setEmailError(null);
    }
  };

  return (
    <>
      <div className="test-configuration-container step-card">
        <div className="card-header">
          <div className="card-title">Test Configuration</div>
          <div className="card-subtitle">
            Select users to receive a test phishing email to verify setup before the full campaign
          </div>
        </div>

        <div className="test-config-form">
          <label className="form-label">
            Test recipients <span className="required-asterisk">*</span>
          </label>

          <div className="email-input-wrapper">
            <Select
              mode="tags"
              size="large"
              value={recipients}
              onChange={handleChange}
              placeholder="Enter one or more email addresses"
              tokenSeparators={[',', ' ']}
              className="ml-input-chip"
              dropdownClassName='campaign-setup-filter-option-select'
              style={{ width: '100%' }}
              tagRender={tagRender}>
              {mockRecipients.map((email) => (
                <Option key={email} value={email}>
                  {email}
                </Option>
              ))}
            </Select>{emailError && (
              <div className="ml-input-help-text">
                {emailError}
              </div>
            )}
          </div>
        </div>

        <div className='alert-section'>
          <Alert subtitle='Test emails are sent within a few minutes after the test campaign is started.' />
        </div>
      </div>
      <StepFooter
          onBack={onBack}
          onNext={() => onNext(recipients)}
          nextBtnDisabled={(recipients.length === 0 || !!emailError)}
        />
    </>
  );
};

export default TestConfiguration;